<template>
  <ItemPage
    title="Bancas"
    size="md"
    :actions="actions"
  >
    <template
      v-if="questionBoardsView"
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquise pelo nome ou abreviatura"
        single-line
        hide-details
      />
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
          class="mr-5 ml-5"
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="15"
            :search="search"
            item-key="id"
            @click:row="editQuestionBoard($event)"
          />
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import GenericFormDialog from '@/components/settings/GenericFormDialog.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      questionBoardsView: false,
      questionBoardsCreate: false,
      loading: false,
      loadingMsg: '',
      request: false,
      dialogAddBoard: false,
      renderComponent: 0,
      contents: [],
      snackbar: false,
      msgSnackbar: '',
      timeout: 3000,
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Banca',
          action: this.openGenericFormDialog,
          icon: 'mdi-plus',
          disabled: !this.questionBoardsCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.questionBoardsView = utils.checkPermissions('question-boards.view-any')
      this.questionBoardsCreate = utils.checkPermissions('question-boards.create')
      this.getQuestionBoards()
    },
    async getQuestionBoards () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const content = await this.$api.getQuestionBoards()
        this.contents = content
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível listar bancas, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editQuestionBoard (event) {
      this.$router.push({ name: 'bancas.id', params: { id: event.id } })
    },
    openGenericFormDialog () {
      this.$dialog.custom(GenericFormDialog).with({ title: 'banca' }).show()
        .then((questionBoard) => {
          if (!questionBoard) {
            return
          }
          this.newQuestionBoard(questionBoard)
        })
    },
    async newQuestionBoard (data) {
      this.loadingMsg = 'Salvando...'
      try {
        await this.$api.newQuestionBoard(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    }
  }
}
</script>
